export default function Footer() {
  return (
    <footer className="bg-accent-900 text-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-20">
        <div className="max-w-[1280px] mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-14">
            <div>
              <h4 className="font-heading text-xl font-bold mb-4 text-background-50">MuleBuy Hub</h4>
              <p className="text-background-50/70 text-sm leading-relaxed">
                Your trusted resource for mulebuy spreadsheet guides, product discovery tools, and curated category navigation. We help you find the best mulebuy spreadsheets for smarter shopping.
              </p>
            </div>

            <div>
              <h4 className="font-label text-xs uppercase tracking-wider text-background-50/60 mb-4 font-semibold">Newsletter</h4>
              <form
                data-readdy-form
                id="newsletter-form"
                action="https://readdy.ai/api/form/d8sn09rf81iibef4bpj0"
                method="POST"
              >
                <div className="flex border-b border-background-50/30 pb-2">
                  <input
                    type="email"
                    name="email"
                    placeholder="Your email address"
                    className="bg-transparent text-background-50 text-sm placeholder:text-background-50/40 outline-none flex-1"
                    required
                  />
                  <button type="submit" className="text-background-50 cursor-pointer hover:text-background-50/80 transition-colors">
                    <i className="ri-arrow-right-line text-lg"></i>
                  </button>
                </div>
                <p className="text-background-50/40 text-xs mt-2">
                  Get the latest mulebuy spreadsheet updates.
                </p>
              </form>
            </div>

            <div>
              <h4 className="font-label text-xs uppercase tracking-wider text-background-50/60 mb-4 font-semibold">Quick Links</h4>
              <div className="flex flex-col gap-2.5">
                <a href="/" className="text-background-50/70 text-sm hover:text-background-50 transition-colors cursor-pointer">Home</a>
                <a href="/mulebuy-spreadsheet-guide" className="text-background-50/70 text-sm hover:text-background-50 transition-colors cursor-pointer">MuleBuy Spreadsheet Guide</a>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-background-50/70 text-sm hover:text-background-50 transition-colors cursor-pointer">Main Platform</a>
              </div>
            </div>

            <div>
              <h4 className="font-label text-xs uppercase tracking-wider text-background-50/60 mb-4 font-semibold">Resources</h4>
              <div className="flex flex-col gap-2.5">
                <a href="#categories" className="text-background-50/70 text-sm hover:text-background-50 transition-colors cursor-pointer">Categories</a>
                <a href="#faq" className="text-background-50/70 text-sm hover:text-background-50 transition-colors cursor-pointer">FAQ</a>
                <a href="#guides" className="text-background-50/70 text-sm hover:text-background-50 transition-colors cursor-pointer">Guides</a>
              </div>
            </div>
          </div>

          <div className="border-t border-background-50/15 pt-8">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-background-50/50 text-xs">
                &copy; 2026 MuleBuy Spreadsheet Hub. All rights reserved. This site is an independent resource and is not affiliated with any agent platform.
              </p>
              <p className="text-background-50/40 text-xs">
                Last Updated: June 2026 &middot; Spreadsheet database refreshed weekly
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}